module.exports = __webpack_public_path__ + "img/index-manual-step-5@3x.087ede48.png";